module.exports = __webpack_public_path__ + "static/img/伙伴客户-中辕中医.260d0ddd.png";